export const APPROVED = 'active';
export const REJECTED = 'rejected';
export const PERMANENT_REJECTED = 'permanentRejected';
export const PENDING = 'pendingApproval';
export const PENDING_ONLY = 'pending';
export const BANNED = 'banned';
export const RESUBMITTED = 'resubmitted';
export const REJECTED_ONCE = 'Rejected Once';
export const REJECTED_PERMANENT = 'Rejected Permanent';
export const BLOG = 'blog';
export const BLOGS = 'blogs';
export const ARABIC = 'ar';
export const ENGLISH = 'en';
export const BLOGDETAILS = 'blog-details'
export const BLOGPHOTOS = 'blog-photos'

export const userTypeIs = {
  provider: 'tutor',
  customer: 'student',
  user: 'User',
};
// user schema Tutor
const userSchema = {
  "publicData": {
    "aboutMe": "My Bio", // in ProfilePage for bio  
    "country": "USA", // user's country in Profile page
    "education": [    // Tutor's education --> Profile page 
      {
        "description": "description 1",     //education description 
        "endYear": "2024",                  //education start year
        "startYear": "2022",                //education end year
        "title": "title"                    // Education title
      },

    ],
    "languagePreference": "ar",             //Tutor language preference
    "phoneNumber": "1234567890",            // Tutor phone number
    "shortTitle": "Short Title",           // about me with some experience
    "spokenLanguage": [                      // Tutor spoken languages
      {
        "key": "es",
        "label": "Spanish",
        "value": "es"
      },
      {
        "key": "hi",
        "label": "Hindi",
        "value": "hi"
      },
      {
        "key": "en",
        "label": "English",
        "value": "en"
      }
    ],
    "tagline": "Tagline",         //tagline : some motivative line 
    "userType": " User Type : Tutor"
  }
}
// listing schema 
const listingSchema = {
  "publicData": {
    "aboutMe": "My Bio",          //listing bio
    "country": "USA",             // author country
    "education": [                 // author education
      {
        "description": "description 1",
        "endYear": "2024",
        "startYear": "2022",
        "title": "frfrfr"
      },

    ],
    "languagePreference": "ar",     //author language prefernce
    "shortTitle": "Short Title",   // about author with some experience
    "spokenLanguage": [            // Tutor spoken languages
      {
        "key": "es",
        "label": "Spanish",
        "value": "es"
      },
      {
        "key": "hi",
        "label": "Hindi",
        "value": "hi"
      },
      {
        "key": "en",
        "label": "English",
        "value": "en"
      }
    ],
    "tagline": "Tagline",    //tagline : some motivative line
    "certifications": [           // Tutor certifications in language with certicates names and cloudinary links
      {
        "certificateNames": [
          "Platform Notifications and Emails (1)"
        ],
        "certificateUrls": [
          "https://res.cloudinary.com/dnuammhgf/image/upload/v1759929453/users/68e4b463-8419-4b83-b0df-6b0ac9e94628/certifications/yappxw7grglwetzri0kr.pdf"
        ],
        "certificationsDescription": "frfrfrfrf",
        "certificationsEndYear": "2024",
        "certificationsStartYear": "2023",
        "title": "frfrfrffrfrf"
      }
    ],
    "expertise": [           // Tutor extpertise in fileds
      "conversational_arabic",
      "dialects",
      "quranic_arabic",
      "msa"
    ],
    "levels": [              //Tutor language expertise multi check
      "beginner",
      "intermediate"
    ],
    "listingType": "book-seats",
    "priceVariants": [
      {
        "bookingLengthInMinutes": 60,
        "priceInSubunits": 2300
      }
    ],
    "startTimeInterval": "hour",
    "teachingLanguage": "Arabic",
    "transactionProcessAlias": "default-booking/release-1",
    "workExperience": [     //author/ Tutor work experience
      {
        "title": "Title",
        "workExperienceDescription": "Description",
        "workExperienceEndYear": "2022",
        "workExperienceStartYear": "2024"
      }
    ]
  }
}

const walletSchema = {
  sourceId: "e4huh4b4b5465b56bj3b$67878",  // could be orderId, giftCardId, payoutId, etc.
  userId: "userId",   //User's id 
  type: ["credit", "debit"],
  amount: 50,
  balanceBefore: 0, //amount before the credit or debit 
  balanceAfter: 50,//amount after the credit or debit,
  source: [
    "gift_card",
    "deposit",
    "refund",
    "purchase",
    "booking_income",
    "withdrawal",
    "adjustment",
  ],
  status: ["pending", "success", "failed"], //status of the transaction
  metadata: "metaData" // flexible for extra details (refferal id )
}

export const allSpokenLanguages = [
  { value: 'en', key: 'en', label: 'English', label: 'English', label_ar: 'الإنجليزية' },
  { value: 'hi', key: 'hi', label: 'Hindi', label: 'Hindi', label_ar: 'الهندية' },
  { value: 'es', key: 'es', label: 'Spanish', label: 'Spanish', label_ar: 'الإسبانية' },
  { value: 'fr', key: 'fr', label: 'French', label: 'French', label_ar: 'الفرنسية' },
  { value: 'de', key: 'de', label: 'German', label: 'German', label_ar: 'الألمانية' },
  { value: 'zh', key: 'zh', label: 'Chinese (Mandarin)', label: 'Chinese (Mandarin)', label_ar: 'الصينية (الماندارين)' },
  { value: 'ja', key: 'ja', label: 'Japanese', label: 'Japanese', label_ar: 'اليابانية' },
  { value: 'ko', key: 'ko', label: 'Korean', label: 'Korean', label_ar: 'الكورية' },
  { value: 'ar', key: 'ar', label: 'Arabic', label: 'Arabic', label_ar: 'العربية' },
  { value: 'pt', key: 'pt', label: 'Portuguese', label: 'Portuguese', label_ar: 'البرتغالية' },
  { value: 'ru', key: 'ru', label: 'Russian', label: 'Russian', label_ar: 'الروسية' },
  { value: 'it', key: 'it', label: 'Italian', label: 'Italian', label_ar: 'الإيطالية' },
  { value: 'bn', key: 'bn', label: 'Bengali', label: 'Bengali', label_ar: 'البنغالية' },
  { value: 'pa', key: 'pa', label: 'Punjabi', label: 'Punjabi', label_ar: 'البنجابية' },
  { value: 'mr', key: 'mr', label: 'Marathi', label: 'Marathi', label_ar: 'الماراثية' },
  { value: 'te', key: 'te', label: 'Telugu', label: 'Telugu', label_ar: 'التيلجو' },
  { value: 'ta', key: 'ta', label: 'Tamil', label: 'Tamil', label_ar: 'التاميلية' },
  { value: 'ur', key: 'ur', label: 'Urdu', label: 'Urdu', label_ar: 'الأردية' },
  { value: 'gu', key: 'gu', label: 'Gujarati', label: 'Gujarati', label_ar: 'الغوجاراتية' },
  { value: 'ml', key: 'ml', label: 'Malayalam', label: 'Malayalam', label_ar: 'المالايالامية' },
  { value: 'kn', key: 'kn', label: 'Kannada', label: 'Kannada', label_ar: 'الكانادا' },
  { value: 'or', key: 'or', label: 'Odia', label: 'Odia', label_ar: 'الأورية' },
  { value: 'as', key: 'as', label: 'Assamese', label: 'Assamese', label_ar: 'الأسامية' },
  { value: 'ne', key: 'ne', label: 'Nepali', label: 'Nepali', label_ar: 'النيبالية' },
  { value: 'si', key: 'si', label: 'Sinhala', label: 'Sinhala', label_ar: 'السنهالية' },
  { value: 'th', key: 'th', label: 'Thai', label: 'Thai', label_ar: 'التايلاندية' },
  { value: 'tr', key: 'tr', label: 'Turkish', label: 'Turkish', label_ar: 'التركية' },
  { value: 'vi', key: 'vi', label: 'Vietnamese', label: 'Vietnamese', label_ar: 'الفيتنامية' },
  { value: 'fa', key: 'fa', label: 'Persian (Farsi)', label: 'Persian (Farsi)', label_ar: 'الفارسية (فارسي)' },
  { value: 'he', key: 'he', label: 'Hebrew', label: 'Hebrew', label_ar: 'العبرية' },
  { value: 'id', key: 'id', label: 'Indonesian', label: 'Indonesian', label_ar: 'الإندونيسية' },
  { value: 'ms', key: 'ms', label: 'Malay', label: 'Malay', label_ar: 'الملايوية' },
  { value: 'sw', key: 'sw', label: 'Swahili', label: 'Swahili', label_ar: 'السواحيلية' },
  { value: 'nl', key: 'nl', label: 'Dutch', label: 'Dutch', label_ar: 'الهولندية' },
  { value: 'pl', key: 'pl', label: 'Polish', label: 'Polish', label_ar: 'البولندية' },
  { value: 'ro', key: 'ro', label: 'Romanian', label: 'Romanian', label_ar: 'الرومانية' },
  { value: 'uk', key: 'uk', label: 'Ukrainian', label: 'Ukrainian', label_ar: 'الأوكرانية' },
  { value: 'el', key: 'el', label: 'Greek', label: 'Greek', label_ar: 'اليونانية' },
  { value: 'hu', key: 'hu', label: 'Hungarian', label: 'Hungarian', label_ar: 'الهنغارية' },
  { value: 'cs', key: 'cs', label: 'Czech', label: 'Czech', label_ar: 'التشيكية' },
  { value: 'sv', key: 'sv', label: 'Swedish', label: 'Swedish', label_ar: 'السويدية' },
  { value: 'fi', key: 'fi', label: 'Finnish', label: 'Finnish', label_ar: 'الفنلندية' },
  { value: 'da', key: 'da', label: 'Danish', label: 'Danish', label_ar: 'الدانماركية' },
  { value: 'no', key: 'no', label: 'Norwegian', label: 'Norwegian', label_ar: 'النرويجية' },
  { value: 'bg', key: 'bg', label: 'Bulgarian', label: 'Bulgarian', label_ar: 'البلغارية' },
  { value: 'sr', key: 'sr', label: 'Serbian', label: 'Serbian', label_ar: 'الصربية' },
  { value: 'hr', key: 'hr', label: 'Croatian', label: 'Croatian', label_ar: 'الكرواتية' },
  { value: 'sk', key: 'sk', label: 'Slovak', label: 'Slovak', label_ar: 'السلوفاكية' },
  { value: 'sl', key: 'sl', label: 'Slovenian', label: 'Slovenian', label_ar: 'السلوفينية' },
  { value: 'et', key: 'et', label: 'Estonian', label: 'Estonian', label_ar: 'الإستونية' },
  { value: 'lt', key: 'lt', label: 'Lithuanian', label: 'Lithuanian', label_ar: 'الليتوانية' },
  { value: 'lv', key: 'lv', label: 'Latvian', label: 'Latvian', label_ar: 'اللاتفية' },
  { value: 'is', key: 'is', label: 'Icelandic', label: 'Icelandic', label_ar: 'الآيسلندية' },
  { value: 'ga', key: 'ga', label: 'Irish', label: 'Irish', label_ar: 'الأيرلندية' },
  { value: 'cy', key: 'cy', label: 'Welsh', label: 'Welsh', label_ar: 'الويلزية' },
  { value: 'sq', key: 'sq', label: 'Albanian', label: 'Albanian', label_ar: 'الألبانية' },
  { value: 'hy', key: 'hy', label: 'Armenian', label: 'Armenian', label_ar: 'الأرمنية' },
  { value: 'ka', key: 'ka', label: 'Georgian', label: 'Georgian', label_ar: 'الجورجية' },
  { value: 'am', key: 'am', label: 'Amharic', label: 'Amharic', label_ar: 'الأمهرية' },
  { value: 'zu', key: 'zu', label: 'Zulu', label: 'Zulu', label_ar: 'الزولو' },
  { value: 'xh', key: 'xh', label: 'Xhosa', label: 'Xhosa', label_ar: 'الخوسا' },
  { value: 'yo', key: 'yo', label: 'Yoruba', label: 'Yoruba', label_ar: 'اليوروبية' },
  { value: 'ig', key: 'ig', label: 'Igbo', label: 'Igbo', label_ar: 'الإيغبو' },
  { value: 'ha', key: 'ha', label: 'Hausa', label: 'Hausa', label_ar: 'الهوسا' },
  { value: 'mn', key: 'mn', label: 'Mongolian', label: 'Mongolian', label_ar: 'المنغولية' },
  { value: 'km', key: 'km', label: 'Khmer', label: 'Khmer', label_ar: 'الخميرية' },
  { value: 'lo', key: 'lo', label: 'Lao', label: 'Lao', label_ar: 'اللاوية' },
  { value: 'my', key: 'my', label: 'Burmese', label: 'Burmese', label_ar: 'البورمية' },
  { value: 'uz', key: 'uz', label: 'Uzbek', label: 'Uzbek', label_ar: 'الأوزبكية' },
  { value: 'kk', key: 'kk', label: 'Kazakh', label: 'Kazakh', label_ar: 'الكازاخية' },
  { value: 'tg', key: 'tg', label: 'Tajik', label: 'Tajik', label_ar: 'الطاجيكية' },
  { value: 'tk', key: 'tk', label: 'Turkmen', label: 'Turkmen', label_ar: 'التركمانية' },
  { value: 'ps', key: 'ps', label: 'Pashto', label: 'Pashto', label_ar: 'البشتوية' },
  { value: 'ku', key: 'ku', label: 'Kurdish', label: 'Kurdish', label_ar: 'الكردية' },
  { value: 'az', key: 'az', label: 'Azerbaijani', label: 'Azerbaijani', label_ar: 'الأذرية' },
  { value: 'be', key: 'be', label: 'Belarusian', label: 'Belarusian', label_ar: 'البيلاروسية' },
  { value: 'bs', key: 'bs', label: 'Bosnian', label: 'Bosnian', label_ar: 'البوسنية' },
  { value: 'af', key: 'af', label: 'Afrikaans', label: 'Afrikaans', label_ar: 'الأفريكانية' },
  { value: 'eo', key: 'eo', label: 'Esperanto', label: 'Esperanto', label_ar: 'الإسبرانتو' },
  { value: 'la', key: 'la', label: 'Latin', label: 'Latin', label_ar: 'اللاتينية' },
  { value: 'mi', key: 'mi', label: 'Maori', label: 'Maori', label_ar: 'الماورية' },
  { value: 'sm', key: 'sm', label: 'Samoan', label: 'Samoan', label_ar: 'الساموية' },
  { value: 'fj', key: 'fj', label: 'Fijian', label: 'Fijian', label_ar: 'الفيجية' },
  { value: 'so', key: 'so', label: 'Somali', label: 'Somali', label_ar: 'الصومالية' },
  { value: 'tt', key: 'tt', label: 'Tatar', label: 'Tatar', label_ar: 'التترية' },
  { value: 'ky', key: 'ky', label: 'Kyrgyz', label: 'Kyrgyz', label_ar: 'القيرغيزية' },
  { value: 'taq', key: 'taq', label: 'Tamasheq', label: 'Tamasheq', label_ar: 'التماشق' },
  { value: 'rw', key: 'rw', label: 'Kinyarwanda', label: 'Kinyarwanda', label_ar: 'الكينيارواندية' },
  { value: 'ln', key: 'ln', label: 'Lingala', label: 'Lingala', label_ar: 'اللينغالا' },
  { value: 'sn', key: 'sn', label: 'Shona', label: 'Shona', label_ar: 'الشونا' },
  { value: 'ny', key: 'ny', label: 'Chichewa', label: 'Chichewa', label_ar: 'الشيشيوا' },
  { value: 'st', key: 'st', label: 'Sesotho', label: 'Sesotho', label_ar: 'السيسوتو' },
  { value: 'ts', key: 'ts', label: 'Tsonga', label: 'Tsonga', label_ar: 'التسونغا' },
  { value: 'tn', key: 'tn', label: 'Tswana', label: 'Tswana', label_ar: 'التسوانية' },
];
export const expertiseList = [
  {
    value: 'conversational_arabic',
    key: 'conversational_arabic',
    label_en: 'Conversational Arabic',
    label_ar: 'العربية المحكية',
  },
  { value: 'academic_arabic', key: 'academic_arabic', label_en: 'Academic Arabic', label_ar: 'اللغة العربية الأكاديمية' },
  {
    value: 'quranic_arabic',
    key: 'quranic_arabic',
    label_en: 'Quranic Arabic',
    label_ar: 'العربية القرآنية',
  },
  { value: 'msa', key: 'msa', label_en: 'MSA', label_ar: 'العربية الفصحى الحديثة' },
  {
    value: 'business_arabic',
    key: 'business_arabic',
    label_en: 'Business Arabic',
    label_ar: 'العربية للأعمال',
  },
  { value: 'exam_prep', key: 'exam_prep', label_en: 'Exam Prep', label_ar: 'التحضير للامتحانات' },
]

export const arabicCountriesList = [
  { value: 'SA', key: 'SA', label_en: 'Saudi Arabia', label_ar: 'المملكة العربية السعودية', flag: '🇸🇦' },
  { value: 'EG', key: 'EG', label_en: 'Egypt', label_ar: 'مصر', flag: '🇪🇬' },
  { value: 'AE', key: 'AE', label_en: 'United Arab Emirates', label_ar: 'الإمارات العربية المتحدة', flag: '🇦🇪' },
  { value: 'IQ', key: 'IQ', label_en: 'Iraq', label_ar: 'العراق', flag: '🇮🇶' },
  { value: 'MA', key: 'MA', label_en: 'Morocco', label_ar: 'المغرب', flag: '🇲🇦' },
  { value: 'DZ', key: 'DZ', label_en: 'Algeria', label_ar: 'الجزائر', flag: '🇩🇿' },
  { value: 'SY', key: 'SY', label_en: 'Syria', label_ar: 'سوريا', flag: '🇸🇾' },
  { value: 'YE', key: 'YE', label_en: 'Yemen', label_ar: 'اليمن', flag: '🇾🇪' },
  { value: 'TN', key: 'TN', label_en: 'Tunisia', label_ar: 'تونس', flag: '🇹🇳' },
  { value: 'JO', key: 'JO', label_en: 'Jordan', label_ar: 'الأردن', flag: '🇯🇴' },
  { value: 'LY', key: 'LY', label_en: 'Libya', label_ar: 'ليبيا', flag: '🇱🇾' },
  { value: 'LB', key: 'LB', label_en: 'Lebanon', label_ar: 'لبنان', flag: '🇱🇧' },
  { value: 'PS', key: 'PS', label_en: 'Palestine', label_ar: 'فلسطين', flag: '🇵🇸' },
  { value: 'OM', key: 'OM', label_en: 'Oman', label_ar: 'عُمان', flag: '🇴🇲' },
  { value: 'KW', key: 'KW', label_en: 'Kuwait', label_ar: 'الكويت', flag: '🇰🇼' },
  { value: 'QA', key: 'QA', label_en: 'Qatar', label_ar: 'قطر', flag: '🇶🇦' },
  { value: 'BH', key: 'BH', label_en: 'Bahrain', label_ar: 'البحرين', flag: '🇧🇭' },
  { value: 'SD', key: 'SD', label_en: 'Sudan', label_ar: 'السودان', flag: '🇸🇩' },
  { value: 'SO', key: 'SO', label_en: 'Somalia', label_ar: 'الصومال', flag: '🇸🇴' },
  { value: 'MR', key: 'MR', label_en: 'Mauritania', label_ar: 'موريتانيا', flag: '🇲🇷' },
  { value: 'DJ', key: 'DJ', label_en: 'Djibouti', label_ar: 'جيبوتي', flag: '🇩🇯' },
  { value: 'KM', key: 'KM', label_en: 'Comoros', label_ar: 'جزر القمر', flag: '🇰🇲' },
];

export const levelsList = [
  { value: 'beginner', key: 'beginner', label_en: 'Beginner', label_ar: 'مبتدئ' },
  { value: 'intermediate', key: 'intermediate', label_en: 'Intermediate', label_ar: 'متوسط' },
  { value: 'advanced', key: 'advanced', label_en: 'Advanced', label_ar: 'متقدم' },
  { value: 'business', key: 'business', label_en: 'Business', label_ar: 'العربية للأعمال' },
  { value: 'exam_prep', key: 'exam_prep', label_en: 'Exam Prep', label_ar: 'التحضير للامتحانات' },
];

// Standardized experience labeling per platform framework
// Tier is determined strictly by credentials and years of experience.
// Teaching categories (such as Stories & Songs) do NOT override or lower the earned tier.
export const getExperienceParts = (years, intl, options = {}) => {
  const isArabic = (intl?.locale || '').toLowerCase().startsWith('ar');
  const { isCertified = false, isConversationStories = false } = options;
  let tier = '';
  if (isCertified) {
    tier = intl.formatMessage({ id: 'TutorExperience.label.certified', defaultMessage: 'Arabibi Certified' });
  } else if (isConversationStories) {
    // Only applied when explicitly assigned by admin override
    tier = intl.formatMessage({ id: 'TutorExperience.label.stories', defaultMessage: 'Conversation & Stories' });
  } else if (years >= 8) {
    tier = intl.formatMessage({ id: 'TutorExperience.label.senior', defaultMessage: 'Senior Tutor' });
  } else if (years >= 3) {
    tier = intl.formatMessage({ id: 'TutorExperience.label.experienced', defaultMessage: 'Experienced Tutor' });
  } else {
    tier = intl.formatMessage({ id: 'TutorExperience.label.standard', defaultMessage: 'Standard Tutor' });
  }

  let yearsText = '';
  if (typeof years === 'number' && !isNaN(years) && years > 0) {
    if (isArabic) {
      if (years === 1) {
        yearsText = 'سنة واحدة';
      } else if (years === 2) {
        yearsText = 'سنتين';
      } else if (years >= 3 && years <= 10) {
        yearsText = `${years} سنوات`;
      } else {
        yearsText = `${years} سنة`;
      }
    } else {
      yearsText = `${years} ${years === 1 ? 'year' : 'years'}`;
    }
  }

  const fullLabel = yearsText ? `${tier} (${yearsText})` : tier;
  return { tier, yearsText, fullLabel };
};

export const getExperienceLabel = (years, intl, options = {}) => {
  return getExperienceParts(years, intl, options).fullLabel;
};


export const getYearsFromListing = (listing, currentUser) => {
  const pubData = listing?.attributes?.publicData || {};
  const userPubData = currentUser?.attributes?.profile?.publicData || {};

  const numPubYears = Number(pubData.yearsOfExperience);
  if (pubData.yearsOfExperience !== undefined && pubData.yearsOfExperience !== null && !isNaN(numPubYears) && numPubYears > 0) {
    return numPubYears;
  }
  const numUserYears = Number(userPubData.yearsOfExperience);
  if (userPubData.yearsOfExperience !== undefined && userPubData.yearsOfExperience !== null && !isNaN(numUserYears) && numUserYears > 0) {
    return numUserYears;
  }

  // Fallback: calculate from workExperience if available
  const workExperience = (Array.isArray(pubData.workExperience) && pubData.workExperience.length > 0)
    ? pubData.workExperience
    : userPubData.workExperience;

  if (Array.isArray(workExperience) && workExperience.length > 0) {
    const nowY = new Date().getFullYear();
    const normalized = (sRaw, eRaw) => {
      const s = parseInt(sRaw, 10);
      let e = parseInt(eRaw, 10);
      if (!Number.isFinite(s)) return null;
      const isOngoing = !Number.isFinite(e) || e < s;
      const endInclusive = isOngoing ? nowY : e;
      return [s, endInclusive];
    };
    const ranges = workExperience
      .map(r => normalized(r?.workExperienceStartYear, r?.workExperienceEndYear))
      .filter(Boolean)
      .sort((a, b) => a[0] - b[0]);
    let totalYears = 0;
    if (ranges.length > 0) {
      let curS = ranges[0][0];
      let curE = ranges[0][1];
      for (let i = 1; i < ranges.length; i++) {
        const [s, e] = ranges[i];
        if (s <= curE) {
          curE = Math.max(curE, e);
        } else {
          totalYears += Math.max(0, curE - curS);
          curS = s;
          curE = e;
        }
      }
      totalYears += Math.max(0, curE - curS);
    }
    return totalYears;
  }
  // Fallback from teachingExperience string option
  const teRaw = pubData.teachingExperience || userPubData.teachingExperience;
  const te = Array.isArray(teRaw) ? teRaw[0] : teRaw;
  if (te === 'lt_1' || te === '1_3') return 2;
  if (te === '3_5' || te === '3_6') return 4;
  if (te === '5_plus' || te === '6_plus') return 6;
  const teNum = parseInt(te, 10);
  if (Number.isFinite(teNum) && teNum > 0) return teNum;

  return 0; // Default fallback
};

// Canonical age groups for tutor listings and lesson setups
export const ageGroupList = [
  { value: 'kids', key: 'kids', label_en: 'Kids 5–12', label_ar: 'الأطفال 5–12' },
  { value: 'teenagers', key: 'teenagers', label_en: 'Teens 13–17', label_ar: 'الناشئون 13–17' },
  { value: 'adults', key: 'adults', label_en: 'Adults 18 and over', label_ar: 'البالغون 18 فأكثر' },
];


export const specializationsList = [
  { value: 'conversational_arabic', key: 'conversational_arabic', label_en: 'Conversational Arabic', label_ar: 'العربية المحكية' },
  { value: 'quranic_arabic', key: 'quranic_arabic', label_en: 'Quranic Arabic', label_ar: 'العربية القرآنية' },
  { value: 'business_arabic', key: 'business_arabic', label_en: 'Business Arabic', label_ar: 'العربية للأعمال' },
  { value: 'arabic_from_scratch', key: 'arabic_from_scratch', label_en: 'Arabic from Scratch', label_ar: 'العربية من الصفر' },
];

export const lessonTypesList = [
  { value: 'structured', key: 'structured', label_en: 'Structured', label_ar: 'منهجي' },
  { value: 'conversational', key: 'conversational', label_en: 'Conversational', label_ar: 'محادثة' },
  { value: 'both', key: 'both', label_en: 'Both', label_ar: 'كلاهما' },
];

export const dialectsList = [
  { value: 'LB', key: 'LB', label: 'Lebanese', label_en: 'Lebanese', label_ar: 'اللبنانية' },
  { value: 'SY', key: 'SY', label_en: 'Syrian', label_ar: 'السورية' },
  { value: 'JO', key: 'JO', label_en: 'Jordanian', label_ar: 'الأردنية' },
  { value: 'PS', key: 'PS', label_en: 'Palestinian', label_ar: 'الفلسطينية' },
  { value: 'AE', key: 'AE', label_en: 'Emirati', label_ar: 'الإماراتية' },
  { value: 'SA', key: 'SA', label_en: 'Saudi', label_ar: 'السعودية' },
  { value: 'KW', key: 'KW', label_en: 'Kuwaiti', label_ar: 'الكويتية' },
  { value: 'QA', key: 'QA', label_en: 'Qatari', label_ar: 'القطرية' },
  { value: 'BH', key: 'BH', label_en: 'Bahraini', label_ar: 'البحرينية' },
  { value: 'OM', key: 'OM', label_en: 'Omani', label_ar: 'العمانية' },
  { value: 'YE', key: 'YE', label_en: 'Yemeni', label_ar: 'اليمنية' },
  { value: 'IQ', key: 'IQ', label_en: 'Iraqi', label_ar: 'العراقية' },
  { value: 'EG', key: 'EG', label_en: 'Egyptian', label_ar: 'المصرية' },
  { value: 'SD', key: 'SD', label_en: 'Sudanese', label_ar: 'السودانية' },
  { value: 'LY', key: 'LY', label_en: 'Libyan', label_ar: 'الليبية' },
  { value: 'TN', key: 'TN', label_en: 'Tunisian', label_ar: 'التونسية' },
  { value: 'DZ', key: 'DZ', label_en: 'Algerian', label_ar: 'الجزائرية' },
  { value: 'MA', key: 'MA', label_en: 'Moroccan', label_ar: 'المغربية' },
  { value: 'msa', key: 'msa', label_en: 'Modern Standard Arabic', label_ar: 'اللغة العربية الفصحى' },
];

export const teachingLanguagesList = [
  { value: 'arabic', key: 'arabic', label: 'Arabic', label_en: 'Arabic', label_ar: 'العربية' },
  { value: 'english', key: 'english', label: 'English', label_en: 'English', label_ar: 'الإنجليزية' },
  { value: 'french', key: 'french', label: 'French', label_en: 'French', label_ar: 'الفرنسية' },
  { value: 'spanish', key: 'spanish', label: 'Spanish', label_en: 'Spanish', label_ar: 'الإسبانية' },
  { value: 'german', key: 'german', label: 'German', label_en: 'German', label_ar: 'الألمانية' },
  { value: 'turkish', key: 'turkish', label: 'Turkish', label_en: 'Turkish', label_ar: 'التركية' },
  { value: 'urdu', key: 'urdu', label: 'Urdu', label_en: 'Urdu', label_ar: 'الأوردية' },
];

export const TEACHING_LANG_TO_SPOKEN_MAP = {
  arabic: ['ar', 'arabic'],
  english: ['en', 'english'],
  french: ['fr', 'french'],
  spanish: ['es', 'spanish'],
  german: ['de', 'german'],
  turkish: ['tr', 'turkish'],
  urdu: ['ur', 'urdu'],
};

export const isSpokenLanguageSelected = (spokenLanguages, teachingLangKey) => {
  if (!Array.isArray(spokenLanguages) || spokenLanguages.length === 0) return false;
  const matchValues = TEACHING_LANG_TO_SPOKEN_MAP[teachingLangKey] || [teachingLangKey];
  return spokenLanguages.some(item => {
    const val = (typeof item === 'string' ? item : item?.value || item?.key || item?.label || '')
      .toLowerCase()
      .trim();
    return matchValues.includes(val);
  });
};

export const getAvailableTeachingLanguages = (spokenLanguages) => {
  return teachingLanguagesList.filter(langOpt =>
    isSpokenLanguageSelected(spokenLanguages, langOpt.value)
  );
};

// Pricing panel: session length options (in minutes)
export const SESSION_TIME_MINUTES = [50];
// Explicit options with human-readable labels
export const SESSION_TIME_OPTIONS = [
  { value: 50, label_en: '50 Min Session', label_ar: 'جلسة 50 دقيقة' },
];

// Price Bands (5 tiers)
export const PRICE_BANDS = {
  conversation_stories: {
    key: 'conversation_stories',
    name_en: 'Conversation & Stories',
    name_ar: 'محادثة وقصص',
    min: 15,
    max: 22,
    description_en: 'conversation practice & stories only, no structured curriculum',
    description_ar: 'ممارسة المحادثة والقصص فقط، بدون منهج منظم',
  },
  tutor: {
    key: 'tutor',
    name_en: 'Standard Tutor',
    name_ar: 'معلم معتمد',
    min: 23,
    max: 30,
    description_en: '',
    description_ar: '',
  },
  experienced_tutor: {
    key: 'experienced_tutor',
    name_en: 'Experienced Tutor',
    name_ar: 'معلم ذو خبرة',
    min: 31,
    max: 40,
    description_en: '',
    description_ar: '',
  },
  senior_tutor: {
    key: 'senior_tutor',
    name_en: 'Senior Tutor',
    name_ar: 'معلم أول',
    min: 41,
    max: 50,
    description_en: '',
    description_ar: '',
  },
  arabibi_certified: {
    key: 'arabibi_certified',
    name_en: 'Arabibi Certified',
    name_ar: 'معتمد من عربي - بي',
    min: 51,
    max: 60,
    description_en: 'nobody qualifies yet - we will start this programme next year, but please build the band now',
    description_ar: 'لا أحد مؤهل بعد - سنبدأ هذا البرنامج العام المقبل',
  },
};

export const PRICE_BAND_OPTIONS = [
  {
    key: 'conversation_stories',
    value: 'conversation_stories',
    min: 15,
    max: 22,
    label_en: 'Conversation & Stories: $15-22 (conversation practice & stories only, no structured curriculum)',
    label_ar: 'محادثة وقصص: 15-22$ (ممارسة المحادثة والقصص فقط، بدون منهج منظم)',
    name_en: 'Conversation & Stories',
    name_ar: 'محادثة وقصص',
    description_en: 'conversation practice & stories only, no structured curriculum',
    description_ar: 'ممارسة المحادثة والقصص فقط، بدون منهج منظم',
  },
  {
    key: 'tutor',
    value: 'tutor',
    min: 23,
    max: 30,
    label_en: 'Standard Tutor: $23-30',
    label_ar: 'معلم معتمد: 23-30$',
    name_en: 'Standard Tutor',
    name_ar: 'معلم معتمد',
    description_en: '',
    description_ar: '',
  },
  {
    key: 'experienced_tutor',
    value: 'experienced_tutor',
    min: 31,
    max: 40,
    label_en: 'Experienced Tutor: $31-40',
    label_ar: 'معلم ذو خبرة: 31-40$',
    name_en: 'Experienced Tutor',
    name_ar: 'معلم ذو خبرة',
    description_en: '',
    description_ar: '',
  },
  {
    key: 'senior_tutor',
    value: 'senior_tutor',
    min: 41,
    max: 50,
    label_en: 'Senior Tutor: $41-50',
    label_ar: 'معلم أول: 41-50$',
    name_en: 'Senior Tutor',
    name_ar: 'معلم أول',
    description_en: '',
    description_ar: '',
  },
  {
    key: 'arabibi_certified',
    value: 'arabibi_certified',
    min: 51,
    max: 60,
    label_en: 'Arabibi Certified: $51-60 (launching next year)',
    label_ar: 'معتمد من عربي - بي: 51-60$ (ينطلق العام المقبل)',
    name_en: 'Arabibi Certified',
    name_ar: 'معتمد من عربي - بي',
    description_en: 'nobody qualifies yet - launching next year',
    description_ar: 'لا أحد مؤهل بعد - ينطلق العام المقبل',
  },
];

// Helper to extract teaching category keys from a publicData object
export const getTeachingCategoriesFromPublicData = pd => {
  if (!pd || typeof pd !== 'object') return null;

  const directKeys = [
    'teaching_categories',
    'teachingCategories',
    'teachingcategories',
    'teaching_category',
    'teachingCategory',
    'pub_teaching_categories',
    'pub_teachingCategories',
  ];

  for (const k of directKeys) {
    if (pd[k] !== undefined && pd[k] !== null) {
      const arr = Array.isArray(pd[k]) ? pd[k] : [pd[k]];
      return arr
        .map(item => {
          if (typeof item === 'string') return item;
          if (item && typeof item === 'object') {
            return item.key || item.value || item.option || item.id || item.label || '';
          }
          return '';
        })
        .filter(Boolean);
    }
  }

  // Heuristic for custom keys
  for (const [key, val] of Object.entries(pd)) {
    const normKey = String(key).toLowerCase().replace(/^pub_/, '').replace(/[_-\s]/g, '');
    if (
      normKey === 'teachingcategories' ||
      normKey === 'teachingcategory' ||
      (normKey.includes('teaching') && normKey.includes('categor'))
    ) {
      if (val !== undefined && val !== null) {
        const arr = Array.isArray(val) ? val : [val];
        return arr
          .map(item => {
            if (typeof item === 'string') return item;
            if (item && typeof item === 'object') {
              return item.key || item.value || item.option || item.id || item.label || '';
            }
            return '';
          })
          .filter(Boolean);
      }
    }
  }

  return null;
};

// Helper to check whether a single category identifier corresponds to Stories & Songs
export const isStoriesCategoryValue = val => {
  if (!val) return false;
  const str = String(val).toLowerCase().trim();
  const norm = str.replace(/[^a-z0-9]/g, '');
  return (
    norm.includes('stori') ||
    norm.includes('story') ||
    norm === 'storiesandsongs' ||
    norm === 'storiessongs' ||
    str.includes('قصص')
  );
};

// Helper to check if "Stories & Songs" (or any stories category) is selected in teaching categories
export const hasStoriesCategory = (listing, currentUser) => {
  const listingPd = listing?.attributes?.publicData || {};
  const userPd = currentUser?.attributes?.profile?.publicData || {};

  // Check listing publicData first: if listing has teaching categories defined, evaluate it strictly
  const listingCats = getTeachingCategoriesFromPublicData(listingPd);
  if (listingCats !== null) {
    return listingCats.some(isStoriesCategoryValue);
  }

  // Fallback to user profile publicData only if listing has no teaching categories defined
  const userCats = getTeachingCategoriesFromPublicData(userPd);
  if (userCats !== null) {
    return userCats.some(isStoriesCategoryValue);
  }

  return false;
};

// Helper to determine tutor's assigned or qualified price band.
// Note: Teaching categories (e.g. Stories & Songs) represent WHAT is taught and do NOT alter
// the tutor's price band or tier. Experience always sets the qualified tier and price band.
export const getTutorPriceBand = (listing, currentUser) => {
  const listingPd = listing?.attributes?.publicData || {};
  const userPd = currentUser?.attributes?.profile?.publicData || {};

  // 1. Explicit admin override or Arabibi Certified status
  const explicitAdminKey = listingPd.adminPriceBand || userPd.adminPriceBand;
  if (explicitAdminKey && PRICE_BANDS[explicitAdminKey]) {
    return PRICE_BANDS[explicitAdminKey];
  }
  if (listingPd.priceBand === 'arabibi_certified' || userPd.priceBand === 'arabibi_certified') {
    return PRICE_BANDS.arabibi_certified;
  }

  // 2. Calculated strictly on the basis of years of experience:
  const years = getYearsFromListing(listing, currentUser);
  if (years >= 8) {
    return PRICE_BANDS.senior_tutor;
  }
  if (years >= 3) {
    return PRICE_BANDS.experienced_tutor;
  }

  return PRICE_BANDS.tutor;
};

// Pricing panel: session price categories (backward compatibility)
export const SESSION_PRICE_CATEGORIES = [
  'conversation_stories',
  'tutor',
  'experienced_tutor',
  'senior_tutor',
  'arabibi_certified',
];

export const SESSION_PRICE_CATEGORY_OPTIONS = PRICE_BAND_OPTIONS;


// tags 
export const tagsList = [
  { key: 'arabic_tutor', label_en: 'Arabic tutor', label_ar: 'معلم عربي' },
  { key: 'msa_vs_dialects', label_en: 'MSA vs. Dialects', label_ar: 'العربية الفصحى مقابل اللهجات' },
  { key: 'learning', label_en: 'Learning', label_ar: 'التعلم' },
  { key: 'learning_resources', label_en: 'Learning Resources', label_ar: 'موارد التعلم' },
]

// Countries that use IBAN
export const IBAN_COUNTRIES = [
  'AD', 'AT', 'AZ', 'BH', 'BE', 'BA', 'BG', 'CR', 'HR', 'CY', 'CZ', 'DK',
  'DO', 'EE', 'FO', 'FI', 'FR', 'GE', 'DE', 'GI', 'GR', 'GL', 'GT', 'HU',
  'IS', 'IE', 'IL', 'IT', 'JO', 'KZ', 'KW', 'LV', 'LB', 'LI', 'LT', 'LU',
  'MK', 'MT', 'MR', 'MU', 'MC', 'MD', 'ME', 'NL', 'NO', 'PK', 'PS', 'PL',
  'PT', 'QA', 'RO', 'SM', 'SA', 'RS', 'SK', 'SI', 'ES', 'SE', 'CH', 'TN',
  'TR', 'AE', 'GB', 'VA', 'XK'
];
// Countries with special banking systems
export const SPECIAL_COUNTRIES = {
  US: {
    system: 'aba',
    fields: ['routingNumber', 'accountNumber'],
    currency: 'USD'
  },
  IN: {
    system: 'ifsc',
    fields: ['ifscCode', 'accountNumber', 'branchName'],
    currency: 'INR'
  },
  AU: {
    system: 'bsb',
    fields: ['bsbNumber', 'accountNumber'],
    currency: 'AUD'
  },
  CA: {
    system: 'transit',
    fields: ['institutionNumber', 'transitNumber', 'accountNumber'],
    currency: 'CAD'
  },
  NZ: {
    system: 'nz',
    fields: ['bankNumber', 'branchNumber', 'accountNumber'],
    currency: 'NZD'
  },
  CN: {
    system: 'cn',
    fields: ['bankCode', 'accountNumber', 'branchName'],
    currency: 'CNY'
  },
  HK: {
    system: 'hk',
    fields: ['bankCode', 'branchCode', 'accountNumber'],
    currency: 'HKD'
  },
  SG: {
    system: 'sg',
    fields: ['bankCode', 'branchCode', 'accountNumber'],
    currency: 'SGD'
  },
  JP: {
    system: 'jp',
    fields: ['bankCode', 'branchCode', 'accountNumber'],
    currency: 'JPY'
  },
  KR: {
    system: 'kr',
    fields: ['bankCode', 'accountNumber'],
    currency: 'KRW'
  },
  BR: {
    system: 'br',
    fields: ['bankCode', 'branchCode', 'accountNumber'],
    currency: 'BRL'
  },
  RU: {
    system: 'ru',
    fields: ['bik', 'accountNumber', 'correspondentAccount'],
    currency: 'RUB'
  },
  MX: {
    system: 'mx',
    fields: ['clabe', 'accountNumber'],
    currency: 'MXN'
  },
  ZA: {
    system: 'za',
    fields: ['branchCode', 'accountNumber'],
    currency: 'ZAR'
  }
};

export const currencyMap = {
  SA: 'SAR', AE: 'AED', GB: 'GBP', EU: 'EUR', JP: 'JPY', CN: 'CNY', HK: 'HKD', SG: 'SGD',
  KR: 'KRW', BR: 'BRL', RU: 'RUB', MX: 'MXN', ZA: 'ZAR', CH: 'CHF', SE: 'SEK', NO: 'NOK',
  DK: 'DKK', IN: 'INR', US: 'USD', AU: 'AUD', CA: 'CAD', NZ: 'NZD'
};

/**
 * Country-to-Dialect Mapping for Arabibi Learning & Placement
 * Maps user-facing country dialects to their underlying curriculum cluster and sister regions.
 */
export const COUNTRY_DIALECT_MAP = {
  // Levantine Cluster
  LB: {
    countryCode: 'LB',
    countryName: 'Lebanon',
    arabicCountryName: 'لبنان',
    dialectName: 'Lebanese',
    arabicDialectName: 'اللبنانية',
    flag: '🇱🇧',
    cluster: 'Levantine',
    sisterCountries: ['LB', 'SY', 'JO', 'PS'],
    desc: 'Lebanese spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في لبنان والمحادثة اليومية',
  },
  SY: {
    countryCode: 'SY',
    countryName: 'Syria',
    arabicCountryName: 'سوريا',
    dialectName: 'Syrian',
    arabicDialectName: 'السورية',
    flag: '🇸🇾',
    cluster: 'Levantine',
    sisterCountries: ['SY', 'LB', 'JO', 'PS'],
    desc: 'Syrian spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في سوريا والمحادثة اليومية',
  },
  JO: {
    countryCode: 'JO',
    countryName: 'Jordan',
    arabicCountryName: 'الأردن',
    dialectName: 'Jordanian',
    arabicDialectName: 'الأردنية',
    flag: '🇯🇴',
    cluster: 'Levantine',
    sisterCountries: ['JO', 'PS', 'SY', 'LB'],
    desc: 'Jordanian spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في الأردن والمحادثة اليومية',
  },
  PS: {
    countryCode: 'PS',
    countryName: 'Palestine',
    arabicCountryName: 'فلسطين',
    dialectName: 'Palestinian',
    arabicDialectName: 'الفلسطينية',
    flag: '🇵🇸',
    cluster: 'Levantine',
    sisterCountries: ['PS', 'JO', 'LB', 'SY'],
    desc: 'Palestinian spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في فلسطين والمحادثة اليومية',
  },
  // Gulf Cluster
  AE: {
    countryCode: 'AE',
    countryName: 'United Arab Emirates',
    arabicCountryName: 'الإمارات العربية المتحدة',
    dialectName: 'Emirati',
    arabicDialectName: 'الإماراتية',
    flag: '🇦🇪',
    cluster: 'Gulf',
    sisterCountries: ['AE', 'SA', 'KW', 'QA', 'BH', 'OM'],
    desc: 'Emirati spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في الإمارات والمحادثة اليومية',
  },
  SA: {
    countryCode: 'SA',
    countryName: 'Saudi Arabia',
    arabicCountryName: 'المملكة العربية السعودية',
    dialectName: 'Saudi',
    arabicDialectName: 'السعودية',
    flag: '🇸🇦',
    cluster: 'Gulf',
    sisterCountries: ['SA', 'AE', 'KW', 'QA', 'BH', 'OM'],
    desc: 'Saudi spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في السعودية والمحادثة اليومية',
  },
  KW: {
    countryCode: 'KW',
    countryName: 'Kuwait',
    arabicCountryName: 'الكويت',
    dialectName: 'Kuwaiti',
    arabicDialectName: 'الكويتية',
    flag: '🇰🇼',
    cluster: 'Gulf',
    sisterCountries: ['KW', 'SA', 'AE', 'QA', 'BH', 'OM'],
    desc: 'Kuwaiti spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في الكويت والمحادثة اليومية',
  },
  QA: {
    countryCode: 'QA',
    countryName: 'Qatar',
    arabicCountryName: 'قطر',
    dialectName: 'Qatari',
    arabicDialectName: 'القطرية',
    flag: '🇶🇦',
    cluster: 'Gulf',
    sisterCountries: ['QA', 'AE', 'SA', 'KW', 'BH', 'OM'],
    desc: 'Qatari spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في قطر والمحادثة اليومية',
  },
  BH: {
    countryCode: 'BH',
    countryName: 'Bahrain',
    arabicCountryName: 'البحرين',
    dialectName: 'Bahraini',
    arabicDialectName: 'البحرينية',
    flag: '🇧🇭',
    cluster: 'Gulf',
    sisterCountries: ['BH', 'SA', 'AE', 'KW', 'QA', 'OM'],
    desc: 'Bahraini spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في البحرين والمحادثة اليومية',
  },
  OM: {
    countryCode: 'OM',
    countryName: 'Oman',
    arabicCountryName: 'سلطنة عُمان',
    dialectName: 'Omani',
    arabicDialectName: 'العمانية',
    flag: '🇴🇲',
    cluster: 'Gulf',
    sisterCountries: ['OM', 'AE', 'SA', 'KW', 'QA', 'BH'],
    desc: 'Omani spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في عمان والمحادثة اليومية',
  },
  YE: {
    countryCode: 'YE',
    countryName: 'Yemen',
    arabicCountryName: 'اليمن',
    dialectName: 'Yemeni',
    arabicDialectName: 'اليمنية',
    flag: '🇾🇪',
    cluster: 'Gulf',
    sisterCountries: ['YE', 'SA', 'OM', 'AE', 'KW', 'QA', 'BH'],
    desc: 'Yemeni spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في اليمن والمحادثة اليومية',
  },
  // Iraqi Cluster
  IQ: {
    countryCode: 'IQ',
    countryName: 'Iraq',
    arabicCountryName: 'العراق',
    dialectName: 'Iraqi',
    arabicDialectName: 'العراقية',
    flag: '🇮🇶',
    cluster: 'Iraqi',
    sisterCountries: ['IQ', 'KW', 'SY'],
    desc: 'Iraqi spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في العراق والمحادثة اليومية',
  },
  // Egyptian Cluster
  EG: {
    countryCode: 'EG',
    countryName: 'Egypt',
    arabicCountryName: 'مصر',
    dialectName: 'Egyptian',
    arabicDialectName: 'المصرية',
    flag: '🇪🇬',
    cluster: 'Egyptian',
    sisterCountries: ['EG', 'SD'],
    desc: 'Egyptian spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في مصر والمحادثة اليومية',
  },
  // Sudanese Cluster
  SD: {
    countryCode: 'SD',
    countryName: 'Sudan',
    arabicCountryName: 'السودان',
    dialectName: 'Sudanese',
    arabicDialectName: 'السودانية',
    flag: '🇸🇩',
    cluster: 'Sudanese',
    sisterCountries: ['SD', 'EG'],
    desc: 'Sudanese spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في السودان والمحادثة اليومية',
  },
  // North African (Maghrebi) Cluster
  LY: {
    countryCode: 'LY',
    countryName: 'Libya',
    arabicCountryName: 'ليبيا',
    dialectName: 'Libyan',
    arabicDialectName: 'الليبية',
    flag: '🇱🇾',
    cluster: 'Maghrebi',
    sisterCountries: ['LY', 'TN', 'DZ', 'MA', 'EG'],
    desc: 'Libyan spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في ليبيا والمحادثة اليومية',
  },
  TN: {
    countryCode: 'TN',
    countryName: 'Tunisia',
    arabicCountryName: 'تونس',
    dialectName: 'Tunisian',
    arabicDialectName: 'التونسية',
    flag: '🇹🇳',
    cluster: 'Maghrebi',
    sisterCountries: ['TN', 'DZ', 'MA', 'LY'],
    desc: 'Tunisian spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في تونس والمحادثة اليومية',
  },
  DZ: {
    countryCode: 'DZ',
    countryName: 'Algeria',
    arabicCountryName: 'الجزائر',
    dialectName: 'Algerian',
    arabicDialectName: 'الجزائرية',
    flag: '🇩🇿',
    cluster: 'Maghrebi',
    sisterCountries: ['DZ', 'MA', 'TN', 'LY'],
    desc: 'Algerian spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في الجزائر والمحادثة اليومية',
  },
  MA: {
    countryCode: 'MA',
    countryName: 'Morocco',
    arabicCountryName: 'المغرب',
    dialectName: 'Moroccan',
    arabicDialectName: 'المغربية',
    flag: '🇲🇦',
    cluster: 'Maghrebi',
    sisterCountries: ['MA', 'DZ', 'TN', 'LY'],
    desc: 'Moroccan spoken Arabic and conversational fluency',
    arabicDesc: 'العربية المحكية في المغرب والمحادثة اليومية',
  },
  // Modern Standard Arabic
  MSA: {
    countryCode: 'MSA',
    countryName: 'Modern Standard Arabic',
    arabicCountryName: 'اللغة العربية الفصحى',
    dialectName: 'Modern Standard Arabic',
    arabicDialectName: 'اللغة العربية الفصحى',
    cluster: 'MSA',
    sisterCountries: ['MSA'],
    desc: 'Speaking, reading and writing in official Modern Standard Arabic',
    arabicDesc: 'التحدث والقراءة والكتابة باللغة العربية الفصحى الرسمية والمعيارية',
    noFlag: true,
  },
  // Not sure — help me choose
  NOT_SURE: {
    countryCode: 'NOT_SURE',
    countryName: 'Not sure — help me choose',
    arabicCountryName: 'لست متأكداً — ساعدني في الاختيار',
    dialectName: 'Not sure — help me choose',
    arabicDialectName: 'لست متأكداً — ساعدني في الاختيار',
    cluster: 'MSA',
    sisterCountries: ['MSA'],
    desc: 'We will match you with a tutor who will help guide your dialect choice',
    arabicDesc: 'سنساعدك في اختيار اللهجة الأنسب لأهدافك التعليمية',
    noFlag: true,
  },
};

/**
 * Resolves any dialect identifier, country code, or legacy name to a COUNTRY_DIALECT_MAP entry.
 */
export const getCountryDialect = identifier => {
  if (!identifier) return null;
  const key = String(identifier).trim().toUpperCase();
  if (COUNTRY_DIALECT_MAP[key]) return COUNTRY_DIALECT_MAP[key];

  const lower = String(identifier).trim().toLowerCase();
  const match = Object.values(COUNTRY_DIALECT_MAP).find(
    c =>
      c.dialectName.toLowerCase() === lower ||
      c.countryName.toLowerCase() === lower ||
      c.countryCode.toLowerCase() === lower
  );
  if (match) return match;

  // Legacy mappings fallback
  if (lower === 'levantine') return COUNTRY_DIALECT_MAP.LB;
  if (lower === 'gulf') return COUNTRY_DIALECT_MAP.AE;
  if (lower === 'maghrebi' || lower === 'north_african') return COUNTRY_DIALECT_MAP.MA;
  if (lower.includes('msa') || lower.includes('modern standard')) return COUNTRY_DIALECT_MAP.MSA;
  if (lower.includes('not_sure') || lower.includes('not sure')) return COUNTRY_DIALECT_MAP.NOT_SURE;

  return null;
};

/**
 * Returns the underlying curriculum cluster ('Levantine', 'Gulf', 'Egyptian', 'MSA')
 */
export const getCurriculumCluster = identifier => {
  const cd = getCountryDialect(identifier);
  return cd ? cd.cluster : identifier;
};

